import { access2off, access3off, access4off, access2on, access3on, access4on, accessBanner, IconAlarm } from '@assets/images/main/index';
import { BlueIconPhone, BlueIconRFID, BlueIconRemote, BlueIconWatch, BlueIconWidget } from '@assets/images/icon/blue';
import {
  AdvantageImgD,
  AdvantageImgM,
  AdvantageImgT,
  Falldown1D,
  Falldown1M,
  Falldown1T,
  Falldown2D,
  Falldown2M,
  Falldown2T,
  Falldown3D,
  Falldown3M,
  Falldown3T,
  installationImg1D,
  installationImg1M,
  installationImg1T,
  installationImg2D,
  installationImg2M,
  installationImg2T,
  installationImg3D,
  installationImg3M,
  installationImg3T,
  installationImg4D,
  installationImg4M,
  installationImg4T,
  installationImg5D,
  installationImg5M,
  installationImg5T,
  hardwareImg1D,
  hardwareImg1M,
  hardwareImg1T,
  hardwareImg2D,
  hardwareImg2M,
  hardwareImg2T,
  hardwareImg3D,
  hardwareImg3M,
  hardwareImg3T,
  hardwareImg4D,
  hardwareImg4M,
  hardwareImg4T,
  hardwareImg5D,
  hardwareImg5M,
  hardwareImg5T,
  accessBannerProduct,
  accessBannerBg,
} from '@assets/images/main/access/components/index';
import { IconAccessLiteOff, IconAccessLiteOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dAlert, Icon3dCycle, Icon3dDetect, Icon3dMap2, Icon3dMeter } from '@assets/images/icon';

export default {
  banner: {
    title: 'Access made seamless,<br/>records made automatic.',
    desc: 'When a person with a tag or mobile device approaches, the door opens automatically,<br/>and entry/exit logs are saved in real time on ORBRO OS.',
    productImg: accessBannerProduct,
    bgImg: accessBannerBg,
    schemeTitle: 'Choose the access system that fits you.',
    schemeDesc: 'Need help making a decision?',
    schemeDesc2: 'Contact us at<br/>and our access specialists will assist you.',
    phone: '1522-9928',
  },
  mainPage: {
    product: {
      title: 'Explore product configuration',
      desc: 'Check out the innovative access system product configuration.',
      mobile: {
        title: 'Mobile Access',
        desc: 'The beginning of the access system entering with mobile',
      },
      auto: {
        title: 'Automatic door access',
        desc: 'The beginning of the access system specialized for automatic doors<br/> Applicable to all doors',
      },
      face: {
        title: 'Face recognition access',
        desc: 'Methods of all access such as facial recognition, mobile access, NFC card, etc.',
      },
      accessory: {
        title: 'Access Accessories',
        desc: 'Find out all products related to the access system',
      },
    },
  },

  FAQ: [
    {
      title: 'How does Orbro Access authenticate users?',
      description:
        'Depending on the product, it supports various methods such as BLE (Bluetooth), NFC, and AI face recognition. The default method is location-based access via mobile app.',
    },
    {
      title: 'Can I access without a smartphone?',
      description: 'Yes, you can. By using the dedicated Orbro Access Key tag, access is possible even without a smartphone.',
    },
    {
      title: 'Can it be used in areas without automatic doors?',
      description: 'Yes. Even without automatic doors, Orbro Access can integrate with EM locks or deadbolts to control access.',
    },
    {
      title: 'How are access records stored?',
      description:
        'All logs including access time, duration, and authentication methods are automatically stored in ORBRO OS and are viewable in the admin dashboard.',
    },
    {
      title: 'Can it work in environments with no network connection?',
      description: 'Yes. It can operate in offline mode without a server, although in that case, access logs will not be saved.',
    },
    {
      title: 'Is it possible to integrate with external systems?',
      description:
        'Yes. Access Lite and Access Pro support API integration, making it easy to connect with internal security or access log management systems.',
    },
    {
      title: 'Is face recognition access supported?',
      description: 'Yes, the Access Pro model supports AI-based face recognition. It enables quick, touchless, and secure access.',
    },
  ],

  bannerData: [
    {
      icon: access2on,
      iconInv: access2off,
      image: '',
      iconText: 'Access Auto',
      titleKey: 'The beginning of an access system specialized for automatic doors<br/>Compatible with all types of doors',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/en/access/auto',
    },
    {
      icon: IconAccessLiteOn,
      iconInv: IconAccessLiteOff,
      image: '',
      iconText: 'Access Lite',
      titleKey: 'Face recognition, mobile access, NFC cards, etc.<br/>All access methods supported',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/en/access/lite',
    },
    {
      icon: access3on,
      iconInv: access3off,
      image: '',
      iconText: 'Access Pro',
      titleKey: 'Face recognition, mobile access, NFC cards, etc.<br/>All access methods supported',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/en/access/pro',
    },
    {
      icon: access4on,
      iconInv: access4off,
      image: '',
      iconText: 'Accessories',
      titleKey: 'Explore all<br/>access-related products',
      descKey: 'access.banner.desc',
      sub: 'New',
      link: '/en/access/accessory',
    },
    // Add more objects if there are more groups
  ],

  falldown: {
    left: {
      title: 'Integrate Smartphone Entry Methods,<br/>The Most Modern Access System',
      desc: 'From regular doors to automatic doors and speed gates, you can easily access various entry points in modern society using your smartphone. Experience the most efficient digital transformation using the system closest to our daily lives.',

      fall: [
        {
          title: 'Smartphone Entry',
          desc: 'Access is possible through all iOS/Android smartphones.',
          img: {
            desktop: Falldown1D,
            tablet: Falldown1T,
            mobile: Falldown1M,
          },
        },
        {
          title: 'Smart Watch Entry',
          desc: 'Enjoy more convenient access through a smartwatch.',
          img: {
            desktop: Falldown2D,
            tablet: Falldown2T,
            mobile: Falldown2M,
          },
        },
        {
          title: 'RFID Card Entry',
          desc: 'Access is possible using the existing employee ID card.',
          img: {
            desktop: Falldown3D,
            tablet: Falldown3T,
            mobile: Falldown3M,
          },
        },
      ],
    },

    rightImg: '',
  },

  functions: {
    title: 'The Core is Hardware,<br/>Everything Innovates Smoothly.',
    desc: '',
    line: 2,
    card: [
      {
        img: {
          desktop: hardwareImg1D,
          tablet: hardwareImg1T,
          mobile: hardwareImg1M,
        },
        tag: 'Status LED',
        title: 'Dual-Channel NFC/Bluetooth<br/>Access',
        desc: 'Access through NFC cards and more, from mobile to smartwatch entry.',
        size: '3',
      },
      {
        img: {
          desktop: hardwareImg2D,
          tablet: hardwareImg2T,
          mobile: hardwareImg2M,
        },
        tag: 'Power Supply',
        title: 'Integrated Communication and Power via PoE Usage',
        size: '1',
      },
      {
        img: {
          desktop: hardwareImg3D,
          tablet: hardwareImg3T,
          mobile: hardwareImg3M,
        },
        tag: 'Easy Installation',
        title: 'Convenient Installation<br/>with Dedicated Bracket',
        size: '2',
      },
      {
        img: {
          desktop: hardwareImg4D,
          tablet: hardwareImg4T,
          mobile: hardwareImg4M,
        },
        tag: 'Speaker',
        title: 'Entry Notifications<br/>via Speaker',
        size: '2',
      },
      {
        color: '#000',
        img: {
          desktop: hardwareImg5D,
          tablet: hardwareImg5T,
          mobile: hardwareImg5M,
        },
        tag: 'Status LED',
        darkTitle: 'Status Check<br/>',
        lightTitle: 'Even on Dark Nights',
        darkTitle2: '',
        desc: 'With RGB LED, you can check device status, entry confirmation, and more.',
        size: '2',
      },
    ],
  },

  installation: {
    title: `Don't Worry About Product Installation.< br /> We've Got It Covered for You.`,
    card: [
      {
        img: {
          desktop: installationImg1D,
          tablet: installationImg1T,
          mobile: installationImg1M,
        },
        tag: 'On-Premises Server Provided',
        title: 'Enterprise-Grade<br/>Server Provided',
      },
      {
        img: {
          desktop: installationImg2D,
          tablet: installationImg2T,
          mobile: installationImg2M,
        },
        tag: 'Professional On-Site Installation Support',
        title: 'Contact Us<br/> +82) 1522-9928',
        desc: 'Weekdays, 9 AM - 6 PM',
      },
      {
        img: {
          desktop: installationImg3D,
          tablet: installationImg3T,
          mobile: installationImg3M,
        },
        tag: 'Entry Accessories',
        title: 'Deadbolt Installation Possible',
      },
      {
        img: {
          desktop: installationImg4D,
          tablet: installationImg4T,
          mobile: installationImg4M,
        },
        tag: 'Entry Accessories',
        title: 'EM Lock Installation Possible',
      },
      {
        theme: 'black',
        img: {
          desktop: installationImg5D,
          tablet: installationImg5T,
          mobile: installationImg5M,
        },
        tag: 'Entry Accessories',
        title: 'Electric Strike Installation Possible',
      },
    ],
  },

  advantage: {
    img: {
      desktop: AdvantageImgD,
      tablet: AdvantageImgT,
      mobile: AdvantageImgM,
    },
    title: 'What Sets ORBRO Apart<br/>from Traditional Access Systems',
    desc: 'ORBRO is the most modern access terminal that offers various entry methods, adapting to the changing access methods in modern society, from traditional access methods to the latest smart technologies. It provides users with convenient and secure access environments.',
    card: [
      {
        icon: BlueIconPhone,
        title: 'Access with Your Smartphone',
        desc: 'Control entry points using iOS/Android apps.',
      },
      {
        icon: BlueIconWidget,
        title: 'Widget Available',
        desc: 'Widgets are a convenient way to use the mobile app.',
      },
      {
        icon: BlueIconWatch,
        title: 'Access with Smartwatch',
        desc: 'Experience convenient entry methods using a smartwatch.',
      },
      {
        icon: BlueIconRemote,
        title: 'Remote Control',
        desc: 'Administrators can manage entry points remotely.',
      },
      {
        icon: BlueIconRFID,
        title: 'RFID & NFC Cards',
        desc: 'Control entry points easily by tagging RFID or NFC tags.',
      },
    ],
  },

  func: {
    title: 'Explore more features',

    data: [
      {
        img: IconBlueShield,
        title: 'Access Authentication Methods',
        desc: 'We provide various access authentication methods such as BLE (Bluetooth), NFC, and AI face recognition. Available features may vary by product and can be selected based on your environment.',
      },
      {
        img: IconAlarm,
        title: 'Mobile-Based Automatic Access',
        desc: 'Users with the dedicated app installed can approach the entrance with their smartphone,<br/>and the door will open automatically without any manual action.',
      },
      {
        img: Icon3dMeter,
        title: 'Tag-Based Contactless Access',
        desc: 'Using an Access Key tag allows access authentication without a smartphone.<br/>Simply carrying the tag enables automatic door control.',
      },
      {
        img: Icon3dCycle,
        title: 'Access Permission Management',
        desc: 'Set access permissions by user or area to restrict entry based on security levels.',
      },
      {
        img: Icon3dMap2,
        title: 'Automatic Access Log Storage',
        desc: 'Access time, duration of stay, and authentication methods are saved in real time to ORBRO OS.<br/>Admins can view logs by date or user in the admin page.',
      },
      {
        img: Icon3dAlert,
        title: 'Offline Environment Support',
        desc: 'Operate independently in environments without internet using offline mode. Suitable for areas lacking network infrastructure.',
      },
      {
        img: Icon3dDetect,
        title: 'Supports Auto or Standalone Access',
        desc: 'Even without an automatic door, integration with EM locks or deadbolts allows the device to control the lock and enable access.',
      },
      {
        img: Icon3d3d,
        title: 'API-Based External Integration',
        desc: 'Access Lite and Access Pro models support API integration, enabling connection with other security, attendance, or facility systems.',
      },
    ],
  },
};
